/**
 * Wordmark — Melodimals logo (mascot + name).
 *
 * The name is drawn in the display typeface (Baloo 2) and a warm brand
 * gradient; each word falls on a line of color. The mascot is on the left with
 * a gentle wobble animation (respecting reduce-motion through the global
 * utility). It keeps the "Melodimals" text as an accessible heading.
 */

import type { JSX } from "solid-js";
import { MelodimalMark } from "@/components/brand/melodimal-mark";

interface WordmarkProps {
  /** Mascot size in px. */
  markSize?: number;
  class?: string;
}

export function Wordmark(props: WordmarkProps): JSX.Element {
  return (
    <h1 class={`flex items-center gap-3 select-none ${props.class ?? ""}`}>
      <MelodimalMark size={props.markSize ?? 56} class="animate-wobble drop-shadow-md" />
      {/*
        El degradado se pinta sobre el texto (background-clip). Detrás de los
        glifos colocamos un halo blanco difuminado (duplicado borroso) para que
        los tonos claros de marca sigan legibles sobre el shell índigo oscuro
        (modo oscuro del sistema) sin ensuciar el wordmark en el fondo crema.
      */}
      <span class="relative inline-block">
        <span
          aria-hidden="true"
          class="absolute inset-0 font-display text-4xl font-extrabold tracking-tight blur-[6px] sm:text-5xl"
          style={{ color: "oklch(1 0 0 / 0.35)" }}
        >
          Melodimals
        </span>
        <span
          class="relative font-display text-4xl font-extrabold tracking-tight sm:text-5xl"
          style={{
            "background-image":
              "linear-gradient(95deg, oklch(0.72 0.18 25), oklch(0.8 0.16 60) 52%, oklch(0.7 0.16 300))",
            "-webkit-background-clip": "text",
            "background-clip": "text",
            color: "transparent",
            "-webkit-text-stroke": "0.5px oklch(1 0 0 / 0.18)",
          }}
        >
          Melodimals
        </span>
      </span>
    </h1>
  );
}
